import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`

export const PhoneRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp8};
`
